export const viewDeliveryOrderStatuses = ['delivery created', 'fully delivered', 'order completed', 'partially delivered']
export const viewReturnRequestStatuses = ['fully delivered', 'order completed']
export const viewViewInvoiceStatuses = ['fully delivered', 'order completed']
export const ALL_STATUS = 'All';